import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=c1708d6a"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports